import { render, staticRenderFns } from "./phoneCase.vue?vue&type=template&id=3fb2a104&scoped=true"
import script from "./phoneCase.vue?vue&type=script&lang=js"
export * from "./phoneCase.vue?vue&type=script&lang=js"
import style0 from "./phoneCase.vue?vue&type=style&index=0&id=3fb2a104&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb2a104",
  null
  
)

export default component.exports